/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiNotificaNotificaArchiviaPost$Params {
    /**
     * Id della notifica per cui rimuovere la lettura
     */
    notificaId: number;
}

export function apiNotificaNotificaArchiviaPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiNotificaNotificaArchiviaPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, apiNotificaNotificaArchiviaPost.PATH, 'post');
    if (params) {
        rb.query('notificaId', params.notificaId, {});
    }

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
    );
}

apiNotificaNotificaArchiviaPost.PATH = '/api/notifica/notifica-archivia';
